import ProjectCard from "./ProjectCard";
import { PimsProject, PimsEvent, SelectionState } from "../types";

interface ProjectListProps {
  projects: PimsProject[];
  getProjectEvents: (projectId: string) => PimsEvent[];
  selectionState: SelectionState;
  onProjectSelection: (
    projectId: string,
    checked: boolean,
    projectEvents: PimsEvent[]
  ) => void;
  onEventSelection: (eventId: string, checked: boolean) => void;
  onToggleExpansion: (projectId: string) => void;
}

export default function ProjectList({
  projects,
  getProjectEvents,
  selectionState,
  onProjectSelection,
  onEventSelection,
  onToggleExpansion,
}: ProjectListProps) {
  const { selectedProjects, selectedEvents, expandedProjects } = selectionState;

  if (projects.length === 0) {
    return (
      <div className="text-center text-muted-foreground py-8">
        Aucun projet trouvé
      </div>
    );
  }

  return (
    <div>
      {projects.map((project, index) => {
        if (!project) return null;

        const projectEvents = getProjectEvents(project.id);
        const isExpanded = expandedProjects.has(project.id);
        const isSelected = selectedProjects.has(project.id);

        return (
          <div key={project.id}>
            {/* Separator line (except for first project) */}
            {index > 0 && <div className="border-t border-border my-4" />}

            <ProjectCard
              project={project}
              events={projectEvents}
              isSelected={isSelected}
              isExpanded={isExpanded}
              selectedEvents={selectedEvents}
              onProjectSelection={(projectId, checked) =>
                onProjectSelection(projectId, checked, projectEvents)
              }
              onEventSelection={onEventSelection}
              onToggleExpansion={onToggleExpansion}
            />
          </div>
        );
      })}
    </div>
  );
}
